import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
    container: {
        padding: '15px',
    },
    subHeadersRow: {
        display: 'flex',
        width: '100%',
        height: '20px',
        alignItems: 'center',
        justifyContent: 'space-between',
    },
    subHeader: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 700,
        fontSize: '14px',
        color: '#2C2D3E',
    },
    limitName: {
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '14px',
        color: '#2C2D3E',
    },
    limitInputField: {
        paddingRight: '40px',
    },
    line: {
        position: 'relative',
        width: '100%',
        size: '0px',
        color: '#2c2d3e',
        opacity: 0.3,
        display: 'inline-block',
        align: 'center',
    },
    item: {
        paddingTop: '15px',
        display: 'flex',
        width: '100%',
        height: '65px',
        alignItems: 'center',
        justifyContent: 'space-between',

    },
    switch: {
        marginTop: '-0px'
    },
    errorRow: {
        display: 'flex',
        width: '100%',
        minHeight: '25px',
        alignItems: 'center',
        justifyContent: 'center',
    },

    errorMessage: {
        display: 'flex',
        width: '100%',
        height: '25px',
        marginBottom: '-17px',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(188, 0, 0, 0.1)',
        fontFamily: 'Roboto',
        fontStyle: 'normal',
        fontWeight: 400,
        fontSize: '12px',
        color: '#BC0000',
    }
}),
);